var render, staticRenderFns
import script from "./anchoredHeading.vue?vue&type=script&lang=js&"
export * from "./anchoredHeading.vue?vue&type=script&lang=js&"
import style0 from "./anchoredHeading.vue?vue&type=style&index=0&id=4167cb26&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports